/**
 * Public API for the Highcharts wrapper.
 *
 * The Chart component is lazy-loaded so that the full Highcharts library
 * (~1.7 MB) is never pulled into the entry chunk. Consumers just import
 * { Chart } and it works — the Suspense boundary and async loading are
 * handled here.
 */
import React, { Suspense } from 'react';
import type { ICommonAttributes } from '@highcharts/react';

const LazyChart = React.lazy(() => import('./chart').then((m) => ({ default: m.Chart })));

type ChartProps = ICommonAttributes & { palette?: string[] };

export function Chart(props: ChartProps) {
  return (
    <Suspense fallback={<ChartPlaceholder {...props} />}>
      <LazyChart {...props} />
    </Suspense>
  );
}

// Reserves the same space as the real chart while the chunk loads.
function ChartPlaceholder({ containerProps }: ChartProps) {
  return <div style={containerProps?.style} />;
}
